import type { SVGProps } from 'react';

const Play = (props: SVGProps<SVGSVGElement>) => (
    <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M0 17.1C0 7.65593 7.65593 0 17.1 0C26.5441 0 34.2 7.65593 34.2 17.1C34.2 26.5441 26.5441 34.2 17.1 34.2C7.65593 34.2 0 26.5441 0 17.1Z"
            fill="white"
            fillOpacity="0.3"
        />
        <path
            d="M17.0996 0.5C26.2674 0.5 33.7 7.93186 33.7002 17.0996C33.7002 26.2675 26.2675 33.7002 17.0996 33.7002C7.93186 33.7 0.5 26.2674 0.5 17.0996C0.500211 7.93199 7.93199 0.500211 17.0996 0.5Z"
            stroke="white"
            strokeOpacity="0.5"
        />
        <path
            d="M14.1075 11.3291L23.085 17.1004L14.1075 22.8716V11.3291Z"
            fill="white"
            stroke="white"
            strokeWidth="1.2825"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Play;
